import { useAtom } from 'jotai';
import { ISubmenu } from 'src/components/navbar/Sublinks/Sublinks.type';
import { currentSubpageAtom } from '../appState.atoms';

// This hook is used to get the currentSubpage from the currentSubpageAtom
export default function useCurrentSubpage(): [ISubmenu] {
	const [currentSubpage] = useAtom(currentSubpageAtom);
	return [currentSubpage];
}
